
(() => {
  const init = () => {
    if (!document.querySelector('.jtg-hero, .jtg-nav')) return;
    document.documentElement.classList.add('jtg-smooth-scroll');

    document.querySelectorAll('.jtg-nav a[href^="#"], .jtg-hero a[href^="#"]').forEach((link) => {
      if (link.dataset.jtgBound === 'true') return;
      link.dataset.jtgBound = 'true';

      link.addEventListener('click', (event) => {
        const href = link.getAttribute('href');
        if (!href || href === '#') return;
        const target = document.querySelector(href);
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
